module.exports = __webpack_public_path__ + "img/tm.ce3e996.svg";